module.exports = __webpack_public_path__ + "static/media/photo2.bc64199e.jpg";